import { useMemo } from 'react';
import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { useGetMainTokenUSDRatioQuery } from 'modules/api/actions/getMainTokenUSDRatio';
import { useGetStakeTokenRatioQuery } from 'modules/liquidStaking/actions/getStakeTokenRatio';

export function useGetStakeTokenUSDRatio(
  stakePoolAddress?: Address,
): BigNumber | undefined {
  const { data: stakeTokenRatio } = useGetStakeTokenRatioQuery({
    poolAddress: stakePoolAddress,
  });
  const { data: mainTokenUSDRatio } = useGetMainTokenUSDRatioQuery();

  return useMemo(() => {
    return stakeTokenRatio && mainTokenUSDRatio
      ? stakeTokenRatio.multipliedBy(mainTokenUSDRatio)
      : undefined;
  }, [mainTokenUSDRatio, stakeTokenRatio]);
}
